// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

common.View.create('website::layouts.main.Slider', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        new Swiper(this.element.find('.swiper-container').get(0), {
            spaceBetween: 10,

            // If you want pagination
            pagination: {
                el: this.element.find('.swiper-pagination').get(0),
                clickable: true,
            },
        });
    }
});
